import config from '../aws-exports';
import Amplify, { API, Auth } from 'aws-amplify';
import { PostData } from './data-service';

Amplify.configure(config);
//API.configure(config.amplify.API);

const API_NAME = 'photos';
const BASE_PATH = '/post'; 

async function getHeaders(): Promise<any> {
 const headers: any = { };

  // const headers = {
  //   Authorization: `Bearer ${(await Auth.currentSession())
  //     .getIdToken()
  //     .getJwtToken()}`
  // }
  return headers;
}

export async function getPost(postId: string): Promise<PostData> {
    const result = await API.get(API_NAME, `${BASE_PATH}?id=${postId}`, { headers: await getHeaders() });
    console.log(result);
    return result;
}

export async function updatePost(postId: string, updatedPost: PostData) {
  const body = { metadata: updatedPost };
  const result = await API.put(API_NAME, `${BASE_PATH}?id=${postId}`, { body: body, headers: await getHeaders() });
  console.log(result);
  return true;
}

export async function createPost(newPost: PostData): Promise<string> {
    const body = { metadata: newPost };
    const result = await API.post(API_NAME, `${BASE_PATH}`, { body: body, headers: await getHeaders() });
    console.log(result);
    return result.postId;
}